export function artistImageClassName(source: string): string {
  return source.includes('/branding/') || source.toLowerCase().endsWith('.svg') ? 'is-placeholder' : '';
}
